import * as Yup from 'yup'

export const providerTransactionDetailSchema = {
  destinationBankAccount: Yup.string()
}
